import { render } from "./FocusPoints.vue?vue&type=template&id=79cce660"
import script from "./FocusPoints.vue?vue&type=script&lang=js"
export * from "./FocusPoints.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__